export enum APPLICATION_FLOW_STATUS {
  PENDING = 'pending',
  REVIEWED = 'reviewed',
  DECLINED = 'declined',
  SUBMITTED = 'submitted',
}

export interface ApplicationFlowAttributes {
  status: APPLICATION_FLOW_STATUS;
  customer_token: string | null;
  order_number: string | null;
  selected_offer_token?: string | null;
  personal_first_name?: string | null;
  personal_last_name?: string | null;
  personal_street_1?: string | null;
  personal_street_2?: string | null;
  personal_city?: string | null;
  personal_state_province?: string | null;
  personal_postal_code?: string | null;
  personal_birthdate?: string | null;
  personal_ssn?: string | null;
  payapi_customer_card_id?: string | null;
  payapi_customer_id?: string | null;
}

export interface GetApplicationFlowResponse {
  data: {
    id: string;
    type: string;
    attributes: ApplicationFlowAttributes;
  };
}

export interface SubmitApplicationFlowRequestData {
  personal_first_name: string;
  personal_last_name: string;
  personal_birthdate: string;
  personal_ssn: string;
  personal_street_1: string;
  personal_street_2: string;
  personal_city: string;
  personal_state_province: string;
  personal_postal_code: string;
  accepted_legal_agreements: boolean;
}

export interface SubmitApplicationFlowResponse {
  data: {
    id: string;
    type: string;
    attributes: ApplicationFlowAttributes;
  };
}
